// extracted by mini-css-extract-plugin
export default {"container":"MsgMiniPreview_container__576Rq","msgType":"MsgMiniPreview_msgType__-N5uL","linkBtn":"MsgMiniPreview_linkBtn__Lf3IN"};